import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NopagefoundComponent } from './nopagefound.component';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [NopagefoundComponent],
  imports: [CommonModule, RouterModule, TranslateModule],
  exports: [NopagefoundComponent],
})
export class NopagefoundModule {}
